import { Long } from "@osmonauts/helpers";
export const AminoConverter = {
  "/stride.claim.MsgSetAirdropAllocations": {
    aminoType: "/stride.claim.MsgSetAirdropAllocations",
    toAmino: ({
      allocator,
      airdropIdentifier,
      users,
      weights
    }) => {
      return {
        allocator,
        airdrop_identifier: airdropIdentifier,
        users,
        weights
      };
    },
    fromAmino: ({
      allocator,
      airdrop_identifier,
      users,
      weights
    }) => {
      return {
        allocator,
        airdropIdentifier: airdrop_identifier,
        users,
        weights
      };
    }
  },
  "/stride.claim.MsgClaimFreeAmount": {
    aminoType: "claim/ClaimFreeAmount",
    toAmino: ({
      user
    }) => {
      return {
        user
      };
    },
    fromAmino: ({
      user
    }) => {
      return {
        user
      };
    }
  },
  "/stride.claim.MsgCreateAirdrop": {
    aminoType: "/stride.claim.MsgCreateAirdrop",
    toAmino: ({
      distributor,
      identifier,
      startTime,
      duration,
      denom
    }) => {
      return {
        distributor,
        identifier,
        start_time: startTime.toString(),
        duration: duration.toString(),
        denom
      };
    },
    fromAmino: ({
      distributor,
      identifier,
      start_time,
      duration,
      denom
    }) => {
      return {
        distributor,
        identifier,
        startTime: Long.fromString(start_time),
        duration: Long.fromString(duration),
        denom
      };
    }
  },
  "/stride.claim.MsgDeleteAirdrop": {
    aminoType: "/stride.claim.MsgDeleteAirdrop",
    toAmino: ({
      distributor,
      identifier
    }) => {
      return {
        distributor,
        identifier
      };
    },
    fromAmino: ({
      distributor,
      identifier
    }) => {
      return {
        distributor,
        identifier
      };
    }
  }
};